<app-page-header [heading]="'Combo Products'" [icon]="'fa-shopping-basket'" style="height:100px;"></app-page-header>
<div class="page-panel ">
  <div class="col-lg-12 ">
    <div class="row ">
      <div class="col-lg-8"></div>
      <div class="col-lg-4">
        <div class="row">
          <div class="input-group ">
            <input (keydown)="keyDownFunction($event)" [(ngModel)]="combo.search_combo" class="form-control"
                   id="typeahead-http"
                   name="search_text" placeholder="Combo Description ..." style="height:31px"
                   type="text">
            <div class="input-group-append">
              <button (click)="clear_search()" *ngIf="combo.search_combo != ''" class="input-group-text"
                      style="height:31px;padding:7px">
                <i *ngIf="combo.search_combo != ''" class="fa fa-close"></i>
              </button>
            </div>
          </div>
          <div *ngIf="this.status == 'Failed'"><span [hidden]="this.status == 'Success'"
                                                     style="color:red;font-size:13px;"> Sorry, suggestions could not be loaded.</span>
          </div>

          <div class="pull-right">
            <a class="btn  btn-success btn-sm ng-star-inserted" routerLink="/combo-products/add-combo-products"
               title="Create combo product">&nbsp;<i
              class="fa fa-plus text-white"></i>&nbsp;</a>&nbsp;&nbsp;
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="">
    <table class="table tbl  table-bordered">
      <tbody>
      <tr *ngIf="(combo_datas | json) == '[]'">
        <td class="text-center" colspan="10">No data to list</td>
      </tr>
      <ng-container *ngFor="let items of combo_datas;let i=index">
        <tr style="font-weight: bolder;background-color: rgb(20, 128, 170);color: white;">
          <th class="text-center"><label>{{ i + 1 }}</label></th>
          <th colspan="9"> {{ items.DESCRIPTION }}
            <label class="pull-right">
              {{ utils.datetime(items.CREATED_DATE) }}
            </label>
          </th>
          <th class="text-center">
            <button (click)="delete(items)" alt="Delete" class="btn btn-xs"
                    style="font-size: 12px;background-color: white;"
                    title="Delete"><i class="text-danger fa fa-trash"></i></button>&nbsp;&nbsp;&nbsp;
          </th>
        </tr>
        <tr class="text-center" style="background-color:rgb(233, 236, 238);font-weight: bolder;">
          <td class="text-center">Sl</td>
          <td class="text-center" width="35%">Particular</td>
          <td class="text-center">Base Price</td>
          <td class="text-center">Available Qty</td>
          <td class="text-center">Qty</td>
          <td class="text-center">Cost</td>
          <td class="text-center">Slab</td>
          <td class="text-center">Slab Price</td>
          <td class="text-center">Price</td>
          <td class="text-center">Margin</td>
          <td class="text-center">MRP</td>
        </tr>
        <tr *ngFor="let item of items.COMBO;let i=index">
          <td class="text-center">{{ 1 + i }}</td>
          <td> {{ item.TRADE_NAME }}</td>
          <td class="text-right">{{ item.UNIT_PRICE }}</td>
          <td class="text-center">{{ item.AVAILABLE_QUANTITY }}</td>
          <td class="text-center">{{ item.QUANTITY }}</td>
          <td class="text-right">{{ item.COST }}</td>
          <td class="text-center">
            <ng-container *ngIf="item.SLAB == 1">Slab A</ng-container>
            <ng-container *ngIf="item.SLAB == 2">Slab B</ng-container>
            <ng-container *ngIf="item.SLAB == 3">Slab C</ng-container>
          </td>
          <td class="text-right">{{ item.SLAB_PRICE }}</td>
          <td class="text-right">{{ item.PRICE }}</td>
          <td class="text-right">{{ item.MARGIN }}</td>
          <td class="text-right">{{ item.MRP }}</td>
        </tr>
        <tr style="font-weight: bolder;background-color:rgb(233, 236, 238);">
          <td colspan="5">Total</td>
          <td class="text-right">{{ items.TOTAL_COST }}</td>
          <td colspan="2"></td>
          <td class="text-right">{{ items.TOTAL_PRICE }}</td>
          <td class="text-right">{{ items.TOTAL_MARGIN }}</td>
          <td class="text-right">{{ items.TOTAL_MRP }}</td>
        </tr>
      </ng-container>
      </tbody>
    </table>
    <app-pagination (pageChange)="getComboList($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>
  </div>
</div>
<ng-template let-modal>
  <div class="modal-header">
    <div class="pull-right">
      <h3 class="modal-title" id="modal-basic-title">
        Combo Products
      </h3>
    </div>
    <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div class="panel-body">
          <table class="table tbl  table-bordered">
            <thead>
            <tr class="text-center">
              <th>Sl</th>
              <th width="35%">Particular</th>
              <th>Base Price</th>
              <th>Available Qty</th>
              <th>Qty</th>
              <th>Cost</th>
              <th>Slab</th>
              <th>Slab Price</th>
              <th>Price</th>
              <th>MRP</th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let items of combo_datas;let i=index">
              <tr style="font-weight: bolder;">
                <td colspan="10">
                  <label>
                    {{ i + 1 }}
                  </label>&nbsp;&nbsp;&nbsp;&nbsp;
                  {{ items.DESCRIPTION }}
                </td>
              </tr>
              <tr *ngFor="let item of items.COMBO;let i=index">
                <td class="text-center">{{ 1 + i }}</td>
                <td> {{ item.TRADE_NAME }}</td>
                <td class="text-right">{{ item.UNIT_PRICE }}</td>
                <td class="text-center">{{ item.AVAILABLE_QUANTITY }}</td>
                <td class="text-center">{{ item.QUANTITY }}</td>
                <td class="text-right">{{ item.COST }}</td>
                <td class="text-center">
                  <ng-container *ngIf="item.SLAB == 1">Slab A</ng-container>
                  <ng-container *ngIf="item.SLAB == 2">Slab B</ng-container>
                  <ng-container *ngIf="item.SLAB == 3">Slab C</ng-container>
                </td>
                <td class="text-right">{{ item.SLAB_PRICE }}</td>
                <td class="text-right">{{ item.PRICE }}</td>
                <td class="text-right">{{ item.MRP }}</td>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-template>
